module.exports = __webpack_public_path__ + "static/PTW_Logo_RGB_185_15_34 (002)-496f6fd59c72e5889b83b5aea3331b0a.jpg";